import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isInitialised, otpPending, otpEnabled } = useAuth();

  if (!isInitialised) return null;

  if (!isAuthenticated) {
    return <Redirect to="/auth/login" />;
  }

  if (otpPending) {
    return otpEnabled
      ? <Redirect to="/auth/otp" />
      : <Redirect to="/auth/otp-setup" />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
